<template>
  <v-row>
    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">
          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 
              class="font-weight-regular pb-4">
              Color de texto/iconos para los botones o la barra de categorías:
            </h3>

            <v-radio-group v-model="project_gallery_mode">
              <v-radio
                label="Blanco"
                :value="true"
              ></v-radio>

              <v-radio
                label="Negro"
                :value="false"
              ></v-radio>

            </v-radio-group>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Idea Proyecto:</h3>
          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Logo Idea Proyecto:</h4>
            <v-file-input
              outlined
              v-if="!idea_project_logo"
              v-model="idea_project_logo"
              :rules="rules"
              @change="onLogoIPChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo categoria Idea Proyecto"
              :messages="['Para una mejor visualización, usar una imagen de maximo 280x210 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
           ></v-file-input>

           <v-row class="d-flex justify-center">

             <v-card
               v-if="idea_project_logo"
               width="280px"
               max-height="330px"
               class="mb-8">

               <v-img
                class="ma-4"
                 fixed
                 :src="url_idea_project_logo"
                 max-height="280px"
                 max-width="280px"
               ></v-img>
 
               <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn icon>
                   <v-icon color="black" @click="deleteLogoIP()">mdi-delete</v-icon>
                 </v-btn>
               </v-card-actions>
             </v-card> 
           </v-row>

          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Color Idea Proyecto:</h4>
            
            <v-sheet
              :color="idea_project_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="idea_project_color"
              outlined
              :maxlength="20"
              :counter="20"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre corto no debe tener mas de 20 caracteres']"
              label="Color"
              required
            ></v-text-field>

          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">
          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Idea Proyecto Escuelas:</h3>
          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Logo Idea Proyecto Escuelas:</h4>
            <v-file-input
              outlined
              v-if="!idea_project_school_logo"
              v-model="idea_project_school_logo"
              :rules="rules"
              @change="onLogoIPSchoolChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo categoria Idea Proyecto"
              :messages="['Para una mejor visualización, usar una imagen de maximo 280x210 px, y si tiene transparencia asegurarse de que sea formato PNG.']">
            </v-file-input>
            <v-row class="d-flex justify-center">
              <v-card
                v-if="idea_project_school_logo"
                width="280px"
                max-height="330px"
                class="mb-8">

                <v-img
                  class="ma-4"
                  fixed
                  :src="url_idea_project_school_logo"
                  max-height="280px"
                  max-width="280px"
                ></v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteLogoIPSchool()">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card> 
            </v-row>
          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Color Idea Proyecto Escuelas:</h4>
            
            <v-sheet
              :color="idea_project_school_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="idea_project_school_color"
              outlined
              :maxlength="20"
              :counter="20"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre corto no debe tener mas de 20 caracteres']"
              label="Color"
              required
            ></v-text-field>

          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Modelo de Negocios:</h3>
          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Logo Modelo de Negocios:</h4>
            <v-file-input
              outlined
              v-if="!business_model_logo"
              v-model="business_model_logo"
              :rules="rules"
              @change="onLogoBusinessModelChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo categoria Idea Proyecto"
              :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
           ></v-file-input>
            <v-row class="d-flex justify-center">
              <v-card
                v-if="business_model_logo"
                width="280px"
                max-height="330px"
                class="mb-8">

                <v-img
                  class="ma-4"
                  fixed
                  :src="url_business_model_logo"
                  max-height="280px"
                  max-width="280px"
                ></v-img>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteLogoBusinessModel()">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card> 
            </v-row>
          </v-col>

          <v-col 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h4 class="font-weight-regular mb-4">Color Modelo de Negocios:</h4>
            
            <v-sheet
              :color="business_model_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="business_model_color"
              outlined
              :maxlength="20"
              :counter="20"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre corto no debe tener mas de 20 caracteres']"
              label="Color"
              required
            ></v-text-field>

          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationProjectGallery',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      
      customization:[],

      project_gallery_mode:true,

      idea_project_color: null,
      idea_project_logo: null,
      url_idea_project_logo: null,

      idea_project_school_color: null,
      idea_project_school_logo: null,
      url_idea_project_school_logo: null,

      business_model_color: null,
      business_model_logo: null,
      url_business_model_logo: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization

          this.project_gallery_mode = (response.data.data.customization.project_gallery_mode)?true:false
          this.idea_project_color = response.data.data.customization.idea_project_color
          this.idea_project_logo = response.data.data.customization.idea_project_logo
          this.url_idea_project_logo = APP_URL+ this.idea_project_logo

          this.idea_project_school_color = response.data.data.customization.idea_project_school_color
          this.idea_project_school_logo = response.data.data.customization.idea_project_school_logo
          this.url_idea_project_school_logo = APP_URL+ this.idea_project_school_logo

          this.business_model_color = response.data.data.customization.business_model_color
          this.business_model_logo = response.data.data.customization.business_model_logo
          this.url_business_model_logo = APP_URL+ this.business_model_logo

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        
        formData.append('project_gallery_mode', (this.project_gallery_mode) ? 1 : 0 )

        formData.append('idea_project_color', this.idea_project_color)
        formData.append('idea_project_logo', this.idea_project_logo)

        formData.append('idea_project_school_color', this.idea_project_school_color)
        formData.append('idea_project_school_logo', this.idea_project_school_logo)

        formData.append('business_model_color', this.business_model_color)
        formData.append('business_model_logo', this.business_model_logo)
        
        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-project-gallery',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      },


      onLogoIPChange() {
        this.url_idea_project_logo = URL.createObjectURL(this.idea_project_logo);
      },

      deleteLogoIP(){
        this.idea_project_logo=null
        this.url_idea_project_logo=null
      },

      onLogoIPSchoolChange() {
        this.url_idea_project_school_logo = URL.createObjectURL(this.idea_project_school_logo);
      },

      deleteLogoIPSchool(){
        this.idea_project_school_logo=null
        this.url_idea_project_school_logo=null
      },

      onLogoBusinessModelChange() {
        this.url_business_model_logo = URL.createObjectURL(this.business_model_logo);
      },

      deleteLogoBusinessModel(){
        this.business_model_logo=null
        this.url_business_model_logo=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
